import { PACKAGE_GROUP_GYLDENDAL, PACKAGE_GROUP_ORDBOGEN } from "@/common/package-groups-types";

export const PACKAGE_GROUPS_PRIORITIZED = [PACKAGE_GROUP_ORDBOGEN, PACKAGE_GROUP_GYLDENDAL];
